import en from './en/shared-data.json';
import es from './es/shared-data.json';
import eu from './eu/shared-data.json';

const data = { en, es, eu };
const getSharedData = (lang = 'en') => data[lang];

export { getSharedData };
